module.exports = __webpack_public_path__ + "static/media/loewy-3.142aacfe.jpg";